import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "windows",
  "use": "windows-usage",
  "viewBox": "0 0 475.082 475.082",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 475.082 475.082\" id=\"windows\"><path d=\"M0 409.705l194.716 26.836V250.677H0zM0 226.692h194.716V38.544L0 65.38zM216.129 439.398l258.953 35.684V250.674H216.129zM216.132 35.688v191.004h258.95V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol